module.exports = __webpack_public_path__ + "static/media/img3-1.27e717cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/biosense/diff/img3-1.png
// module id = 1898
// module chunks = 3